module.exports = __webpack_public_path__ + "static/fonts/FiraSans-Light.716a1f5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-Light.ttf
// module id = 1156
// module chunks = 5